export * from "ce/pages/Editor/EntityEditor/ConvertToModuleInstanceCTA";
import { default as CE_ConvertToModuleInstanceCTA } from "ce/pages/Editor/EntityEditor/ConvertToModuleInstanceCTA";
export default CE_ConvertToModuleInstanceCTA;
